import getStore from '../store/store';
/**
 * Gets initial state of shared calendar options store
 */
export default function () {
    return getStore().initialState;
}
//# sourceMappingURL=getCalendarSharingInitialState.js.map